import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import BankScopeField from '../../components/BankScopeField';
import ScopeField from '../../components/ScopeField';
import LotterySearchModal from '../../components/LotterySearchModal';
import ParametresLoterieResultsView from './ParametresLoterieResultsView';
import { resolveLotteryByCode } from '../../utils/lotteryLookup';
import './ParametresLoteriePage.css';

const jourOptions = ['Tout', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

const ParametresLoteriePage = () => {
  const [filter, setFilter] = useState('Tout');
  const [scopeId, setScopeId] = useState('');
  const [scopeName, setScopeName] = useState('');
  const [lottery, setLottery] = useState('0');
  const [lotteryName, setLotteryName] = useState('TOUS');
  const [lotteryLookupError, setLotteryLookupError] = useState('');
  const [showLotteryModal, setShowLotteryModal] = useState(false);
  const [jour, setJour] = useState('Tout');
  const [showResults, setShowResults] = useState(false);

  const handleFilterChange = (opt) => {
    setFilter(opt);
    setScopeId('');
    setScopeName('');
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setShowResults(true);
  };

  // Quitter le champ Loterie : résout le code tapé -> nom affiché à côté.
  const handleLotteryBlur = async () => {
    const c = String(lottery).trim();
    if (c === '') { setLotteryLookupError(''); return; }
    const res = await resolveLotteryByCode(c);
    if (res) {
      setLottery(res.code);
      setLotteryName(res.name);
      setLotteryLookupError('');
    } else {
      setLotteryLookupError('Loterie introuvable');
    }
  };

  if (showResults) {
    return (
      <ParametresLoterieResultsView
        lottery={lottery}
        lotteryName={lotteryName}
        jour={jour}
        filter={filter}
        scopeId={scopeId}
        setLottery={setLottery}
        setLotteryName={setLotteryName}
        onBack={() => setShowResults(false)}
      />
    );
  }

  return (
    <Layout>
      <p className="pl-breadcrumb">
        Ruta : <Link to="/dashboard" className="bc-link">Menu</Link>
        {' >> '}
        <Link to="/controles" className="bc-link">Controles</Link>
        {' >> '}
        <span className="bc-current">Parametres de loterie</span>
      </p>

      <div className="pl-card">
        <div className="pl-card-header">
          <span className="pl-card-title">Loteries Parametres (Haiti)</span>
        </div>
        <div className="pl-card-body">
          <div className="pl-radio-row">
            {['Tout', 'Groupe', 'Superviseur', 'Banque'].map((opt) => (
              <label key={opt} className="pl-radio-label">
                <input
                  type="radio"
                  name="filter"
                  value={opt}
                  checked={filter === opt}
                  onChange={() => handleFilterChange(opt)}
                />
                {opt}
              </label>
            ))}
          </div>

          {filter !== 'Tout' && (
            <div className="pl-row pl-scope-row">
              <label className="pl-label">{filter}</label>
              {(filter === 'Banque' || filter === 'Superviseur') ? (
                <BankScopeField
                  id={scopeId}
                  name={scopeName}
                  onResolve={(id, name) => { setScopeId(id); setScopeName(name); }}
                  inputClass="pl-input pl-input-sm"
                  iconClass="pl-icon-btn"
                  nameClass="pl-scope-name"
                  errClass="pl-lookup-err"
                />
              ) : (
                <ScopeField
                  filter={filter}
                  id={scopeId}
                  name={scopeName}
                  onResolve={(id, nm) => { setScopeId(id); setScopeName(nm); }}
                  inputClass="pl-input pl-input-sm"
                  iconClass="pl-icon-btn"
                  nameClass="pl-scope-name"
                  errClass="pl-lookup-err"
                />
              )}
            </div>
          )}

          <form onSubmit={handleSearch} className="pl-form">
            <div className="pl-row">
              <label className="pl-label">Loterie</label>
              <input
                className="pl-input pl-input-sm"
                type="text"
                inputMode="numeric"
                value={lottery}
                onChange={e => { setLottery(e.target.value); setLotteryLookupError(''); }}
                onFocus={e => e.target.select()}
                onBlur={handleLotteryBlur}
              />
              <span className="pl-icon-btn" onClick={() => setShowLotteryModal(true)}>🔍</span>
              {lotteryLookupError
                ? <span className="pl-scope-name pl-lookup-err">{lotteryLookupError}</span>
                : lotteryName && <span className="pl-scope-name">{lotteryName}</span>}
            </div>

            {showLotteryModal && (
              <LotterySearchModal
                onSelect={(id, name) => {
                  setLottery(String(id));
                  setLotteryName(name || '');
                  setLotteryLookupError('');
                }}
                onClose={() => setShowLotteryModal(false)}
              />
            )}

            <div className="pl-row">
              <label className="pl-label">Jour</label>
              <select className="pl-select" value={jour} onChange={e => setJour(e.target.value)}>
                {jourOptions.map(opt => <option key={opt}>{opt}</option>)}
              </select>
            </div>

            <button type="submit" className="pl-search-btn">Chercher</button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default ParametresLoteriePage;
